// hooks/useDropdownOptions.js
import { useState, useCallback } from "react";
import { getDepartments } from "api/departments";
import { getDesignations } from "api/designation";
import { getRoles } from "api/roles";
// import { getBranches, getShiftsByBranch } from "api/branches";
import { getBranches } from "api/branches";
import { getSubBranchesByBranch, getShiftsBySubBranch } from "api/subBranches";

export const useDropdownOptions = () => {
  const [options, setOptions] = useState({
    branches: [],
    subBranches: [],
    shifts: [],
    departments: [],
    designations: [],
    roles: [],
  });

  const [loading, setLoading] = useState({
    branches: false,
    subBranches: false,
    shifts: false,
    departments: false,
    designations: false,
    roles: false,
  });

  // Fetch branches (cached)
  const fetchBranches = useCallback(async () => {
    if (options.branches.length > 0) return;
    setLoading(prev => ({ ...prev, branches: true }));
    try {
      const response = await getBranches(1, 100);
      setOptions(prev => ({ ...prev, branches: response.data || [] }));
    } catch (error) {
      console.error("Failed to fetch branches:", error);
    } finally {
      setLoading(prev => ({ ...prev, branches: false }));
    }
  }, [options.branches]);


  // 🔹 Fetch sub branches dependent on branch
  const fetchSubBranches = useCallback(async (branchId) => {
    if (!branchId) {
      setOptions(prev => ({ ...prev, subBranches: [], shifts: [] }));
      return;
    }

    setLoading(prev => ({ ...prev, subBranches: true }));

    try {
      const response = await getSubBranchesByBranch(branchId);

      const data = response.data || response?.data?.data || [];

      setOptions(prev => ({
        ...prev,
        subBranches: data,
        shifts: [], // reset shifts
      }));
    } catch (error) {
      console.error("Failed to fetch subBranches:", error);
    } finally {
      setLoading(prev => ({ ...prev, subBranches: false }));
    }
  }, []);

  // Fetch shifts – dependent on sub branch, always fetches fresh (no cache)
  // const fetchShifts = useCallback(async (subBranchId) => {
  //   console.log('🔵 fetchShifts called at', Date.now(), 'subBranchId:', subBranchId);     // ✅ LOG
  //   if (!subBranchId) {
  //     setOptions(prev => ({ ...prev, shifts: [] }));
  //     return;
  //   }
  //   setLoading(prev => ({ ...prev, shifts: true }));
  //   try {
  //     const response = await getShiftsBySubBranch(subBranchId);
  //     // Adjust based on your actual API response structure
  //     const shiftsData = response.shifts || response.data || [];
  //     setOptions(prev => ({ ...prev, shifts: shiftsData }));
  //   } catch (error) {
  //     console.error("Failed to fetch shifts:", error);
  //   } finally {
  //     setLoading(prev => ({ ...prev, shifts: false }));
  //   }
  // }, []);

  const fetchShifts = useCallback(async (subBranchId) => {
    console.log('🔵 fetchShifts called with subBranchId:', subBranchId);

    if (!subBranchId) {
      setOptions(prev => ({ ...prev, shifts: [] }));
      return;
    }

    setLoading(prev => ({ ...prev, shifts: true }));

    try {
      const response = await getShiftsBySubBranch(subBranchId);

      const shiftsData = response.shifts || response.data || [];

      setOptions(prev => ({ ...prev, shifts: shiftsData }));
    } catch (error) {
      console.error("Failed to fetch shifts:", error);
    } finally {
      setLoading(prev => ({ ...prev, shifts: false }));
    }
  }, []);

  // Fetch departments (cached)
  const fetchDepartments = useCallback(async () => {
    if (options.departments.length > 0) return;
    setLoading(prev => ({ ...prev, departments: true }));
    try {
      const response = await getDepartments(1, 100);
      setOptions(prev => ({ ...prev, departments: response.data || [] }));
    } catch (error) {
      console.error("Failed to fetch departments:", error);
    } finally {
      setLoading(prev => ({ ...prev, departments: false }));
    }
  }, [options.departments]);

  // Fetch designations (cached)
  const fetchDesignations = useCallback(async () => {
    if (options.designations.length > 0) return;
    setLoading(prev => ({ ...prev, designations: true }));
    try {
      const response = await getDesignations(1, 100);
      setOptions(prev => ({ ...prev, designations: response.data || [] }));
    } catch (error) {
      console.error("Failed to fetch designations:", error);
    } finally {
      setLoading(prev => ({ ...prev, designations: false }));
    }
  }, [options.designations]);

  // Fetch roles (cached)
  const fetchRoles = useCallback(async () => {
    if (options.roles.length > 0) return;
    setLoading(prev => ({ ...prev, roles: true }));
    try {
      const response = await getRoles();
      // Adjust according to your API response (roles array may be in response.roles)
      const rolesData = response.roles || response.data || [];
      setOptions(prev => ({ ...prev, roles: rolesData }));
    } catch (error) {
      console.error("Failed to fetch roles:", error);
    } finally {
      setLoading(prev => ({ ...prev, roles: false }));
    }
  }, [options.roles]);

  return {
    options,
    loading,
    fetchBranches,
    fetchSubBranches,
    fetchShifts,
    fetchDepartments,
    fetchDesignations,
    fetchRoles,
  };
};
